import {Spinner} from "@chakra-ui/react";
import * as React from "react";
import {matchRoutes, Navigate, useLocation, useParams} from "react-router-dom";

import {useAuthentication} from "../hooks/AuthenticationProvider";
import {Authority, Paths, UserStatus} from "../model/Constants";
import {isDemo, isInAvataiSite} from "../Utils";

type RequireAuthProps = {
  children: JSX.Element;
  authority?: Authority;
  redirectTo?: string;
};

const RequireAuth = (props: RequireAuthProps) => {
  const authentication = useAuthentication();
  const location = useLocation();

  const params = useParams<{
    publicId: string;
  }>();
  const publicId = params.publicId || "";

  let redirectTo = props.redirectTo || "";
  if (matchRoutes([{path:Paths.TESTS_PUBLIC_ID}], location) && props.redirectTo) {
    redirectTo = props.redirectTo?.replace(":publicId",publicId);
  }

  if ( !authentication.currentUserQuery ||
    authentication.currentUserQuery.isLoading ) {
    return <Spinner />;
  } else if (
    authentication.currentUserQuery.isError ||
    authentication.currentUserQuery.data?.status === 401
  ) {
    if (isInAvataiSite()) {
      return <Navigate to={redirectTo ? (redirectTo as string) : (Paths.AVATAI_INTRO)}
                       state={{ from: location }} replace />;
    } else {
        const loginPath = isDemo() ? Paths.LOGIN_DEMO : Paths.LOGIN;

        return <Navigate to={redirectTo ? (redirectTo as string) : (loginPath)}
                           state={{ from: location }} replace />;
    }

  } else if (authentication.currentUserQuery.data?.data && !authentication.currentUserQuery.data?.data?.email &&
    authentication.currentUserQuery.data?.data?.uGroup &&
    authentication.currentUserQuery.data?.data?.uGroup.trim().includes("DoE-H-F")) {
    return <Navigate to={redirectTo ? (redirectTo as string) : (Paths.LOGIN_FORMD)}
                     state={{ from: location }} replace />;
  } else if (authentication.currentUserQuery.data?.data && authentication.currentUserQuery.data?.data?.status===UserStatus.AVAILABLE &&
      authentication.currentUserQuery.data?.data?.uGroup &&
      authentication.currentUserQuery.data?.data?.uGroup.includes("EDI") && !isDemo()) {
    return <Navigate to={redirectTo ? (redirectTo as string) : (Paths.LOGIN_FORM_EDI)}
                     state={{ from: location }} replace />;
  } else if (authentication.currentUserQuery.data?.data && !authentication.currentUserQuery.data?.data?.name) {
    return <Navigate to={redirectTo ? (redirectTo as string) : (Paths.LOGIN_FORM)}
                     state={{ from: location }} replace />;
  } else if (props.authority && authentication.currentUserQuery.data?.data?.authorities &&
    !authentication.currentUserQuery.data?.data?.authorities?.includes(props.authority) &&
    (!authentication.currentUserQuery.data?.data?.authorities?.includes(Authority.ROLE_ADMIN)) ) {
    return <Navigate to={redirectTo ? (redirectTo as string) : (Paths.HOME)}
                     state={{ from: location }} replace />;
  }


  return props.children;
};

export default RequireAuth;
